<div class="flex-auto flex items-center container">
  <span translate>layout.footer.copyright</span>
</div>
